import { Entidad } from "../Entidad"

export interface IConfiguracionFacturacion {
    EsProductivo: boolean
    FolioPrefijo: string
    FPLUGIN: string
    FApiKey: string
    FSecretKey: string
}

export interface IInfoEmpresaFactura {
    calle: string
    ciudad: string
    /** @example "43000" */
    codpos: string
    colonia: string
    estado: string
    exterior: string
    interior: string
    razon_social: string
    /** @example "General de Ley Personas Morales" */
    regimen_fiscal: string
    rfc: string
}

export interface IFacturaSerie {
    /** @example "Carta Porte de Ingreso" */
    SerieDescription: string
    /** @example 57752 */
    SerieID: number
    /** @example "CI" */
    SerieName: string
    /** @example "Activa" */
    SerieStatus: string
    /** @example "carta_porte_ingreso" */
    SerieType: string
}

// ****************************************************************
// FacturaClientes
// ****************************************************************

export interface IFacturaCliente {
    Alumnos: number[]
    /** @default "Av. Federacion 6" */
    Calle: string
    /** @default "Guadalajara" */
    Ciudad: string
    /** @default "44680" */
    CodigoPostal: string
    /** @default "Centro" */
    Colonia: string
    Contacto: {
        /** @example "Pérez López" */
        Apellidos: string
        /** @example "ejemplo1@email.com" */
        Email: string
        /** @example "ejemplo2@email.com" */
        Email2: string
        /** @example "ejemplo3@email.com" */
        Email3: string
        /** @example "Cliente De Prueba 006.000" */
        Nombre: string
        /** @example "3338777741" */
        Telefono: string
    },
    /** @example "Guadalajara" */
    Delegacion: string
    /** @example "Jalisco" */
    Estado: string
    /** Número interior @example "567" */
    Interior: string
    Localidad: null,
    NumRegIdTrib: null,
    /** Número exterior @example  "1234" */
    Numero: string
    /** @example  "" */
    Pais: string
    /** @example  "GGHA010101006" */
    RFC: string
    /** @example  "Razón de Prueba 006" */
    RazonSocial: string
    /** @example  "Personas Morales con Fines no Lucrativos" */
    Regimen: string
    /** @example  "603" */
    RegimenId: string
    /** @example  "65fcb0d3d8497" */
    UID: string
    UsoCFDI: null,
    cfdis: number,
    cuentas_banco: IFacturaClienteCuentaBanco[]
}

export interface IFacturaClienteCuentaBanco {
    /** @example "SANTANDER" */
    banco: string
    /** @example "1234" */
    cuenta: string
}

export type IFacturaClienteAlumno = Omit<IFacturaCliente, keyof Pick<IFacturaCliente, "Alumnos">>

// ****************************************************************
// FacturaCatalogoSAT
// ****************************************************************

export interface ICatalogoSATRegimenFiscal {
    /** @example "601" */
    key: string
    /** @example "General de Ley Personas Morales" */
    name: string
}

export interface ICatalogoSATPais {
    /** @example "Unión Europea" */
    agrupacion: string
    /** @example "DEU" */
    key: string
    /** @example "Alemania" */
    name: string
}

export interface IUsoCFDI {
    /** @example "G01" */
    key: string
    /** @example "Adquisición de mercancias" */
    name: string
    /** @example "ambos" | "fisica" */
    use: string
}

export interface ICatalogoSATFormaPago {
    /** @example "01" */
    key: string
    /** @example "Efectivo" */
    name: string
}

export interface ICatalogoSATMetodoPago {
    /** @example "PUE", "PPD" */
    key: string
    /** @example "Pago en una sola exhibición", "Pago en parcialidades o diferido", ... */
    name: string
}

export interface ICatalogoSATImpuesto {
}

export interface ICatalogoSATClaveUnidad {
    /** @example "18" */
    key: string
    /** @example "Tambor de cincuenta y cinco galones (EUA)" */
    name: string
}

export interface ICatalogoSATClaveProductServ {
    /** @example "" */
    complement: string
    /** @example "01010101" */
    key: string
    /** @example "Por definir" */
    name: string
}

// ****************************************************************
// FacturaCatalogo
// ****************************************************************

export interface ICatalogoBanco {
    /** @example "002" */
    key: string
    /** @example "BANAMEX" */
    name: string
}

// ****************************************************************
// CFDI INFO
// ****************************************************************

type TTipoPago = Entidad.CFinanzaCategoriaMovimiento.PagoParcial | Entidad.CFinanzaCategoriaMovimiento.PagoCompleto

export interface IPagoInfoFacturarConceptoComplemento {
    NombreAlumno: string
    CURP: string
    NivelEducativo: string
    AutRVOE: string
    RFCPago: string
}

export enum CFacturaCFDIComplementoConcepto {
    _NoAplica = null,
    NoAplica = 0,
    IEDU = 1,
}

// ****************************************************************
// FacturaCFDI - Conceptos Fiscales Procesados
// ****************************************************************

export interface IFacturaCFDIConceptosFiscalesProcesados {
    /** claveFormaPago - fechaPagoMDY @example "1_19/02/2022" */
    GrupoCFDI: string
    Total: number
    IVA: number
    IdMetodoPago: number
    /** @example "01" */
    ClaveFormaPagoSAT: string
    /** @example "Efectivo" */
    NombreFormaPagoSAT: string
    FechaPagoFmt: string
    ConceptosFiscales: IFacturaCFDIConceptoFiscal[]
}

export interface IFacturaCFDIConceptoFiscal {
    IdAgrupador: number,
    Descripcion: string
    ValorUnitario: number
    Importe: number
    Cantidad: number
    ClaveProdServSAT: string | null
    NombreProdServSAT: string | null
    ClaveUnidadSAT: string | null
    NombreUnidadSAT: string | null
    EsFacturable: boolean
    ComplementoRequerido: CFacturaCFDIComplementoConcepto
    MovimientoFinanza: FacturaCFDIMovimientoPago[]
}

export interface FacturaCFDIMovimientoPago {
    Id: number
    IdPadre: number
    NombreCargo: string
    NombrePeriodo: string
    Monto: number
    Tipo: TTipoPago // 6 o 7
    EsFacturable: boolean
    IdFacturaFolio: number // 0 si no ha sido facturado; <0 si tuvo error
    FechaPago: string // "2022-02-19T17:08:33.577544Z"
}